import React, { Fragment, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from "antd"
import MainContext from '@/stores/stores'
import { getUrlParams } from '@/utils/utils'

import styles from './vin.module.scss'

const Breadcrumb: React.FC<{update?: Function}> = (props) => {
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { crumb } = commonStore
  const navigate = useNavigate()
  const { vin } = getUrlParams()

  const reSelected = (item: any, index: number) => {
    let url = ''
    //catalog
    // console.info(item.type)
    // return
    if(vin){
      if(item.type === 'group'){
        url = `/epc/vin?vin=${vin}&samecrumb=true`
      }
      if(item.type === 'subGroup'){
        url = `/epc/vin?vin=${vin}&num=${item.num}&samecrumb=true`
      }
      if(item.type === 'detail'){
        if(item.index || item.index === 0){
          url = `/epc/vin?vin=${vin}&num=${item.num}&index=${item.index}&samecrumb=true`
        }else {
          url = `/epc/vin?vin=${vin}&num=${item.num}&samecrumb=true`
        }
      }
    }

    let groupCrumb = window.sessionStorage.getItem('groupCrumb') || '[]'
    window.sessionStorage.setItem('crumb', groupCrumb)

    crumb.splice(index, crumb.length - index)
    setCommonStore({value: crumb, type: 'crumb'})
    if(props.update){
      props.update()
    }
    navigate(url)
  }

  return (
    <div className={styles.crumb}>
      {
        crumb[0]?.type === 'logo' ? <img src={crumb[0].img} /> : null
      }
      <ul>
        {
          crumb.map((item: any, index: number)=>{

            return (
              item.type !== 'logo' ? (
                <Fragment key={index}>
                  {/* <li>
                    {
                      item.name?.length > 36 ? (
                        <Tooltip title={item.show_name || item.name}>
                          <span>{item.show_name? item.show_name.substring(0, 36) : item.name.substring(0, 36)}...</span>
                        </Tooltip>
                      ): (
                        <>{item.show_name || item.name}</>
                      )
                    }
                  </li>
                  {
                    crumb.length !== index + 1 ? <li>&gt;</li> : null
                  } */}


                  {
                    item.type === 'config' || index === 1 ? (
                      item.name?.length > 36 ? (
                        <Tooltip title={item.show_name || item.name}>
                          <span>{item.show_name? item.show_name.substring(0, 36) : item.name.substring(0, 36)}...</span>
                        </Tooltip>
                      ): (
                        <>{item.show_name || item.name}</>
                      )
                    ): (
                      <span onClick={()=>reSelected(item, index)} className={styles.selected}>
                        {
                          item.name?.length > 36 ? (
                            <Tooltip title={item.show_name || item.name}>
                              <span>{item.show_name? item.show_name.substring(0, 36) : item.name.substring(0, 36)}...</span>
                            </Tooltip>
                          ): (
                            <>{item.show_name || item.name || item.standard_subgroup_name}</>
                          )
                        }
                      </span>
                    )
                  }
                  {/* { 
                    item.type === 'config' || index === 1 ? (
                      <span>{item.show_name || item.name} </span>
                    ): null 
                  } */}
                  {
                    index !== crumb.length - 1 ? <i>&gt;</i> : null
                  }
                </Fragment>
              ): null
            )
          })
        }
      </ul>
    </div>
  )
}

export default Breadcrumb;